export default __webpack_public_path__ + "static/media/error.f3e9673b.png";